var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#55d76a;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GREEN"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 500,
    cy: 500,
    r: 455.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M387.87,336.47c-8.33,4.49-17.82,10.53-26.26,16.21-16,10.79-26.36,28.46-26.88,47.76a178.33,178.33,0,0,0,52.1,131.4l81.34,81.34a178.36,178.36,0,0,0,131.39,52.11c19.3-.52,37-10.86,47.74-26.87,5.69-8.45,11.74-18,16.22-26.31a15.27,15.27,0,0,0-2.64-18l-.07-.07c-25.75-25.74-54.63-44-81.69-53.35A18.21,18.21,0,0,0,560.29,545l-11.14,11.14a18.18,18.18,0,0,1-25.71,0l-13.92-13.92-51.74-51.74-13.9-13.9a18.18,18.18,0,0,1,0-25.71L455,439.74a18.22,18.22,0,0,0,4.33-18.84c-9.37-27.06-27.63-56-53.37-81.7l-.11-.1A15.22,15.22,0,0,0,387.87,336.47Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.7099681b12b7f3ccfcefda3f7d0b791a.svg";
export { ForwardRef as ReactComponent };